import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActiveToast } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { RoleService } from 'src/app/services/role/role.service';
import { SessionCoordinatorService } from 'src/app/services/session/session-coordinator.service';
import { SessionLifecycleEmitterService } from 'src/app/services/session/session-lifecycle-emitter.service';
import { SignalrService } from 'src/app/services/signalr/signalr.service';
import { TickerTapService } from 'src/app/services/ticker-tap/ticker-tap.service';
import { UserAuditService } from 'src/app/services/user-audit/user-audit.service';
import { UserService } from 'src/app/services/user/user.service';
import { UserAuditListComponent } from '../user-audit-list/user-audit-list/user-audit-list.component';
import { environment } from './../../../environments/environment';
import { NotificationResponseInterface } from '../../interfaces/notification/notification-response-interface';
import { Gd2ToastrService } from '../../services/ui/gd2-toastr.service';
import { jwtDecode } from 'jwt-decode';
import { SessionExpiryWarningComponent } from '../session/session-expiry-warning/session-expiry-warning.component';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {

  constructor(
    private userAuditService: UserAuditService,
    public dialog: MatDialog,
    private cookieService: CookieService,
    private spinner: NgxSpinnerService,
    private msalService: MsalService,
    public authService: AuthService,
    private router: Router,
    public roleService: RoleService,
    private notificationService: NotificationService,
    private toaster: Gd2ToastrService,
    private userService: UserService,
    private signarService: SignalrService,
    private sessionCoordinatorService: SessionCoordinatorService,
    private sessionLifecycleEmitter: SessionLifecycleEmitterService,
    public tickerTapMessageService: TickerTapService) { }

  cookieName = environment.cookieName;
  alerts: NotificationResponseInterface[] = [];
  hasRefreshCalled = false;
  @ViewChild("confirmDialogTemplate") confirmDialogTemplate: TemplateRef<any>;
  @ViewChild(UserAuditListComponent) UserAuditListComponent: UserAuditListComponent;
  dialogTexts = {
    successTitle: '',
    cancelTitle: '',
    message: '',
    deviceName: '',
    status: '',
    title: ''
  }
  dialogRef: MatDialogRef<any>;
  warningDialogRef: MatDialogRef<any> | null = null;
  private capWarningToastShown = false;
  private capWarningToastRef: ActiveToast<any> | null = null;
  private capWarningHardExpiryAtEpochMs = 0;
  private capWarningRemainingMinutes = 0;
  private capWarningCountdownIntervalId: ReturnType<typeof setInterval> | null = null;
  private readonly sessionSubscriptions = new Subscription();
  private signalRReconnectTimeoutId: ReturnType<typeof setTimeout> | null = null;
  private accessTokenStartTimeoutId: ReturnType<typeof setTimeout> | null = null;
  private accessTokenIntervalId: ReturnType<typeof setInterval> | null = null;
  ngOnInit(): void {

    this.sessionCoordinatorService.initialize(true);

    this.sessionSubscriptions.add(
      this.sessionLifecycleEmitter.warningShown.subscribe(event => {
        if (event.type === 'cap') {
          if (this.capWarningToastShown) {
            return;
          }
          this.capWarningToastShown = true;
          this.capWarningHardExpiryAtEpochMs = event.hardExpiryAtEpochMs;
          this.openCapWarningToast();
          this.capWarningCountdownIntervalId = setInterval(() => this.refreshCapWarningToastIfMinuteChanged(), 5000);
          return;
        }

        if (this.warningDialogRef) {
          return;
        }
        this.warningDialogRef = this.dialog.open(SessionExpiryWarningComponent, {
          disableClose: true,
          width: '480px',
          panelClass: 'session-expiry-dialog',
          data: event,
        });
        this.warningDialogRef.afterClosed().subscribe(() => {
          this.warningDialogRef = null;
        });
      }),
    );

    this.sessionSubscriptions.add(
      this.sessionLifecycleEmitter.sessionExtended.subscribe(() => {
        if (this.warningDialogRef) {
          this.warningDialogRef.close();
        }
      }),
    );

    this.sessionSubscriptions.add(
      this.sessionLifecycleEmitter.sessionExpired.subscribe(() => {
        if (this.capWarningToastRef) {
          this.toaster.close(this.capWarningToastRef);
          this.capWarningToastRef = null;
        }
        this.stopCapWarningCountdown();
        if (this.warningDialogRef) {
          this.warningDialogRef.close();
        }
      }),
    );

    //Live update message scheduler
    this.signarService.startConnection();
    this.signarService.messageActivateListener();
    this.signarService.messageExpiredListener();

    this.getCurrentActiveMessages();

    this.authService.currentUserToken = this.cookieService.get(this.cookieName + 'access_token');
    let that = this;
    this.getLiveNotification();
    var date = new Date();
    let minute = 1;
    let interval = (minute * 60) * 1000;

    this.signalRReconnectTimeoutId = setTimeout(() => {
      this.signarService.startConnection();
    }, 100000);

    this.accessTokenStartTimeoutId = setTimeout(() => {
      this.accessTokenIntervalId = setInterval(() => {
        that.checkAccessToken(); //to check access_token is near to expire or not every minute
        let current_time = new Date();
        if ((current_time.getMinutes() % 5) == 0) {
            that.getLiveNotification();
        }
      },interval);
      let current_time = new Date();
      if ((current_time.getMinutes() % 5) == 0) {
        that.getLiveNotification();
      }
      that.checkAccessToken(); //to check access_token is near to expire or not every minute
    }, (60 - date.getSeconds()) * 1000);
  }
  ngOnDestroy(): void {
    if (this.signalRReconnectTimeoutId) {
      clearTimeout(this.signalRReconnectTimeoutId);
    }
    if (this.accessTokenStartTimeoutId) {
      clearTimeout(this.accessTokenStartTimeoutId);
    }
    if (this.accessTokenIntervalId) {
      clearInterval(this.accessTokenIntervalId);
    }
    this.stopCapWarningCountdown();
    this.sessionSubscriptions.unsubscribe();
  }

  private openCapWarningToast(): void {
    this.capWarningRemainingMinutes = Math.max(0, Math.ceil((this.capWarningHardExpiryAtEpochMs - Date.now()) / 60000));
    this.capWarningToastRef = this.toaster.open({
      text: `Your session will end in ${this.capWarningRemainingMinutes} minute(s) because the maximum session duration has been reached.`,
      type: 'warning',
      position: 'top-right',
      closeButton: false,
      disableTimeOut: true,
      tapToDismiss: false,
    });
  }

  private refreshCapWarningToastIfMinuteChanged(): void {
    const remainingMinutes = Math.max(0, Math.ceil((this.capWarningHardExpiryAtEpochMs - Date.now()) / 60000));
    if (remainingMinutes === this.capWarningRemainingMinutes) {
      return;
    }
    if (this.capWarningToastRef) {
      this.toaster.close(this.capWarningToastRef);
    }
    this.openCapWarningToast();
  }

  private stopCapWarningCountdown(): void {
    if (this.capWarningCountdownIntervalId) {
      clearInterval(this.capWarningCountdownIntervalId);
      this.capWarningCountdownIntervalId = null;
    }
  }

  getLiveNotification(){
    this.notificationService.getLiveNotifications().subscribe(response => {
      document.querySelector('body').classList.remove(
        'active-notifications-1', 'active-notifications-2', 'active-notifications-3'
      );
      if (response != null && response.data && response.data.length) {
        this.alerts = response.data;
        const maxNotifications = (this.alerts.length < 3) ? this.alerts.length : 3;
        document.querySelector('body').classList.add(`active-notifications-${maxNotifications}`);
      }else{
        this.alerts = [];
      }
    }, err => {
        this.alerts = [];
        let errors = err.error;
        if(Array.isArray(errors)){
          errors.forEach(element => {
            this.toaster.open({
              text: element.msg,
              type: 'danger',
              position: 'top-right',
              duration: 10000
            });
          });
        }
    });
  }
  async refreshToken(){
    const currentAccount = this.msalService.instance.getAllAccounts()[0];
    var silentRequest = {
        scopes: [environment.msal.loginscope],
        account: currentAccount,
        forceRefresh: false
    };

    const tokenResponse = await this.msalService.instance.acquireTokenSilent(silentRequest).then(accessTokenResponse => {
     if (accessTokenResponse != null && accessTokenResponse.accessToken != '') {
        this.cookieService.set(this.cookieName + 'b2baccess_token', accessTokenResponse.accessToken, 1, '/',environment.domainName, false, 'Lax');

        this.authService.refreshToken(accessTokenResponse.idToken).then(res =>res.subscribe(response => {
        if(response){
          this.cookieService.set(this.cookieName + 'access_token', response.data.access_token, 1, '/',environment.domainName, false, 'Lax');
          this.authService.currentUserToken = this.cookieService.get(this.cookieName + 'access_token');
          this.hasRefreshCalled = false;
        }
      }, err => {
        console.log('err',err);
        this.router.navigate(['/session-expired']);
      }));

      }
    }, err => {
      console.log('err',err);
      this.router.navigate(['/session-expired']);
    });
  }
  checkAccessToken(){
    if (this.sessionCoordinatorService.isCapReached()) {
      return;
    }

    let token = this.getDecodedAccessToken(this.cookieService.get(this.cookieName + 'access_token'));
    if(token && token['exp']){
      let expTime = new Date(token['exp'] * 1000);
      let current_time = new Date();
      var diff =(expTime.getTime() - current_time.getTime()) / 1000;
      diff /= (60);
      diff = Math.abs(Math.round(diff));
      if(!this.hasRefreshCalled && (expTime < current_time || diff < parseInt(this.userService.defaultUIConfigurations.rTokenDurationBeforeExpCTokenInMinutes))){ //if token is near to expire in X min then update
        this.hasRefreshCalled = true;
        this.refreshToken();
      }
    }
  }
  getDecodedAccessToken(token: string): any {
    try{
        return jwtDecode(token);
    }
    catch(Error){
        return null;
    }
  }
  Logout() {
    if((localStorage.getItem("isAuditInProgress") != undefined && this.authService.currentRoute == 'user-audit') || (localStorage.getItem("isTemplateEdit") != undefined && this.authService.currentRoute == 'alarm-template') || (localStorage.getItem("isUserEdit") != undefined && this.authService.currentRoute == 'user')){
      this.dialogTexts.message = 'All unsaved changes will be lost. Are you sure you want to exit?';
      if(localStorage.getItem("isUserEdit") != undefined && this.authService.currentRoute == 'user'){
        this.dialogTexts.message = 'All unsaved changes will be lost. Are you sure you want to cancel?';
      }
      this.getConfirmationBox();

    }else{
      this.router.navigate(['/logout']);
    }
  }
  getConfirmationBox() {
    this.dialogTexts = {
        successTitle: 'Yes',
        cancelTitle: 'No',
        message: this.dialogTexts.message,
        deviceName: '',
        status: '',
        title: 'Confirmation',
    }
    const eventPopupModel = new MatDialogConfig();
    eventPopupModel.height = 'auto';
    eventPopupModel.width = '670px';
    eventPopupModel.disableClose = true;
    this.dialogRef = this.dialog.open(this.confirmDialogTemplate, eventPopupModel);
  }
  onCancel() {
    this.dialogRef.close();
  }
  onConfirm() {
    this.spinner.show();
    this.dialogRef.close();
    if(localStorage.getItem("isAuditInProgress") != undefined && this.authService.currentRoute == 'user-audit'){
      this.userAuditService.stopaudit().subscribe(response => {
        localStorage.removeItem("isAuditInProgress");
        this.authService.logOut();
      },err =>{
        this.spinner.hide();
        this.authService.logOut();
        this.roleService.showErrorMsg(err);
      });
    }else{
      localStorage.removeItem("isTemplateEdit");
      localStorage.removeItem("isUserEdit");
      this.authService.logOut();
    }
  }

  getCurrentActiveMessages() {
    this.spinner.show();
    this.tickerTapMessageService.getCurrentActiveTickerTapMessages().subscribe(result => {
      this.spinner.hide();
      if (result && result['data'])
        this.tickerTapMessageService.scheduleMessages = result['data'];
        for(let index = 0; index < this.tickerTapMessageService.scheduleMessages.length; index++){
          this.tickerTapMessageService.scheduleMessages[index].message = "<p class='marqee-mark-p'>" + this.tickerTapMessageService.scheduleMessages[index].htmlMessage + "</p>";
        }
    }, err => {
      this.spinner.hide();
      let errors = err.errors == undefined ? err.error : err.errors;
      if (Array.isArray(errors)) {
        errors.forEach(element => {
          this.toaster.open({
            text: element.msg,
            type: 'danger',
            position: 'top-right',
            duration: 10000
          });
        });
      }
    });
  }
}
